import axios from 'axios';
import { format } from 'date-fns';
import { SET_ERROR, NJ_CERTIFIED_SETTINGS } from "../../types";
import ToastMessage from '../../../components/toast';

export async function getNJCertifiedReport(companyShortName, payrollId) {
    return axios.get(`api/nj-certified-payroll/get-report/${companyShortName}/${payrollId}`, {
        responseType: 'arraybuffer'
    }).catch(er => {
        ToastMessage("Error Processing data", "error");
    });
};

export const getNJCertifiedSettings = (companyShortName, populateEC) => async dispatch => {
    await axios.get(`api/nj-certified-settings/get-settings/${companyShortName}${populateEC ? `/${populateEC}` : ''}`,
    ).then(res => {
        dispatch({
            type: NJ_CERTIFIED_SETTINGS,
            payload: res.data
        });
    }).catch(e => {
        dispatch({
            type: SET_ERROR,
            payload: { e, error: true }
        });
    });
};

export const saveNJCertifiedSettings = payload => async dispatch => {
    await axios.post('api/nj-certified-settings/set-settings', payload).then(res => {
        ToastMessage("Settings successfully updated!", "success");
        dispatch({
            type: NJ_CERTIFIED_SETTINGS,
            payload: res.data
        });
    }).catch(e => {
        ToastMessage(e.message, "error");
        dispatch({
            type: SET_ERROR,
            payload: { e, error: true }
        });
    });
}